<template>
    <div style="width:100%;height:100%;overflow-x:hidden;" class="scrolling-container">
        <login-box :show="xShowingLogin" @oncancel="showLogin(false)" @onlogin="onLoginCallback"></login-box>
        <Loading :show="isLoading"></Loading>

        <filter-menu :filter-info="filterInfo" v-if="showMenu" @onclose="showMenu=false" :listing-type="listingType" :shop-code="shopInfo.shopCode"></filter-menu>

        <layout>
            <template v-slot:topNavBrand>
                <router-link to="/">
                    <span class="navbar-brand" :title="shopInfo.shopName">
                        <span class="glyphicon glyphicon-home"></span>
                        <span class="agx-shop-name">{{shopInfo.shopName}}</span>
                    </span>
                </router-link>
            </template>
            <template v-slot:topNavRight>
                <span v-if="configs.showSearch" class="navbar-brand" style="float:right;">
                    <span class="act-menu-btn glyphicon glyphicon-search" @click="toggleMenu"></span>
                </span>
            </template>
            <template v-slot:topNavMenus>
                <ul class="nav navbar-nav">
                    <li><router-link :to="{name:listingType}"><span class="glyphicon glyphicon-list"></span> {{lang.navi.listing}} </router-link></li>
                    <template v-if="shopInfo.isCartAllowed">
                        <li v-if="hasLogin"><router-link to="/cart"><span class="glyphicon glyphicon-shopping-cart"></span> {{lang.navi.cart}} </router-link></li>
                        <li v-if="!hasLogin"><router-link to="/wishList"><span class="glyphicon glyphicon-shopping-cart"></span> {{lang.navi.wishList}} </router-link></li>
                        <li v-if="hasLogin"><router-link to="/orders"><span class="glyphicon glyphicon-check"></span> {{lang.navi.orders}} </router-link></li>
                        <li><router-link to="about"><span class="glyphicon glyphicon-info-sign"></span> {{lang.navi.about}}  </router-link></li>
                        <li v-if="hasLogin"> <router-link to="/account" @click.prevent="showLogin(true)"><span class="glyphicon glyphicon-user"></span>  {{lang.navi.account}}</router-link></li>
                        <li v-else> <a href="#" @click.prevent="showLogin(true)"><span class="glyphicon glyphicon-user"></span> {{lang.navi.login}} </a></li>
                    </template>
                </ul>
            </template>

            <template v-slot:sideMenu>
                <div class="agx-navbar-shop">
                    <router-link v-if="hasLogin" to="/account">
                        <div style="border-top: 1px solid #ccc; display: block;width: 100%; height: 80px; padding: 29px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                            <span style="font-size:2em;" class="glyphicon glyphicon-user"></span>  {{xAccount.displayName}}
                        </div>
                    </router-link>
                    <router-link to="/">
                        <div style="display: block;width: 100%; height: 80px; padding: 29px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                            <span class="glyphicon glyphicon-home"></span>  {{shopInfo.shopName}}
                        </div>
                    </router-link>
                </div>
                <div class="agx-navbar-shop">
                    <router-link :to="{name:listingType}"><div style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc;"><span class="glyphicon glyphicon-list"></span> {{lang.navi.listing}} </div></router-link>
                    <template v-if="shopInfo.isCartAllowed">

                        <router-link v-if="hasLogin" to="/cart"><div style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; "><span class="glyphicon glyphicon-shopping-cart"></span> {{lang.navi.cart}} </div></router-link>
                        <router-link v-if="!hasLogin" to="/wishList"><div style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; "><span class="glyphicon glyphicon-shopping-cart"></span> {{lang.navi.wishList}} </div></router-link>
                        <router-link v-if="hasLogin" to="/orders"><div style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; "><span class="glyphicon glyphicon-check"></span> {{lang.navi.orders}} </div></router-link>
                        <router-link to="about"><div style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; "><span class="glyphicon glyphicon-info-sign"></span> {{lang.navi.about}}  </div></router-link>
                        <!--<router-link v-if="hasLogin" to="/account" @click.prevent="showLogin(true)"><div style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; "> <span class="glyphicon glyphicon-user"></span>  {{lang.navi.account}}</div></router-link>-->
                        <div v-if="!hasLogin" style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc;cursor:pointer;" @click.prevent="showLogin(true)"><span class="glyphicon glyphicon-user"></span> {{lang.navi.login}}</div>
                    </template>
                </div>

                <div style="text-align:center;height:50px;line-height:50px;font-size:1.5em;">
                    <span v-if="configs.showSearch" class="act-menu-btn glyphicon glyphicon-search" @click="toggleMenu"></span>
                </div>
                <div>
                    <shop-contacts :contacts="shopContacts"></shop-contacts>
                </div>

            </template>

            <template v-slot:topBody>
                <div style="margin:2px;" v-if="showLaws">
                    <laws @onclose="showLaws=false"></laws>
                </div>
                <div :style="{display:showIndexTop?'block':'none'}" v-if="showIndexTop">
                    <index-top :filter-info="filterInfo" :slider-data="sliderData" :configs="configs"></index-top>
                </div>
            </template>

            <template v-slot:leftBody>
                <filter-menu-form :any-change="showMenu" :filter-info="filterInfo" :listing-type="listingType" :shop-code="shopInfo.shopCode"></filter-menu-form>
            </template>
            <template v-slot:body>
                <div>
                    <div style="width:100%;margin:0 auto;">
                        <div>
                            <router-view></router-view>
                            <keep-alive>
                                <router-view name="cacheview"></router-view>
                            </keep-alive>
                            <keep-alive>
                                <router-view name="cacheArticles"></router-view>
                            </keep-alive>
                        </div>
                    </div>
                    <keep-alive>
                        <router-view name="cacheindex"></router-view>
                    </keep-alive>
                </div>

                <div style="position:fixed;bottom:6px;right:10px;text-align:center;z-index:100;" @click="showMsgBox=true;" v-if="listingType==='listing'">
                    <div><span class="btn btn-default act-contact-trigger agx-theme-bg"><img style="height:30px;" :src="srcRoot+'/images/sys/msg.png'" /></span> </div>
                </div>

                <div :style="{display:!showMsgBox?'none':'block'}" class="modal" style="z-index: 12345; background: rgba(1,1,1,0.5); margin-top: 50px;">

                    <div class="agx-contact-popup"
                         style="position:relative;background:white;border-radius:8px;overflow:hidden;
                        margin:0 auto;width:100%;max-width:700px;height:90%;top:10px;color:black;">
                        <div class="agx-theme-bg" style="width:100%;height:35px;line-height:35px;">
                            <div class="col-xs-12 agx-theme-bg">
                                <span>{{shopInfo.shopName}}</span>
                                <span class="btn btn-default" @click="showMsgBox=false" style="float:right;">X</span>
                            </div>
                        </div>

                        <shop-contacts :contacts="shopContacts"></shop-contacts>

                        <div>
                            <div style="width:90%;max-width:400px;height:80%;max-height:300px;margin:0 auto;overflow-y:auto;border:2px solid #ddd;background:white;padding:10px;">
                                <paged-qa v-if="showMsgBox" :to-user-id="shopInfo.shopUserId" page-path="Enquiry" page-query=""
                                          :get-on-created="false"></paged-qa>
                            </div>
                        </div>

                    </div>
                </div>

            </template>

            <template v-slot:footer>
                <div class="agx-shop-footer agx-before">

                </div>
                <div class="agx-shop-footer agx-theme-bg">

                    <div class="agx-footer-container">

                        <div>
                            <img :src="srcRoot+'/images/shop/shops.png'" style="width:25px;" />
                            <span class="agx-shop-name"> {{shopInfo.shopName}}</span>
                            <div class="agx-com-attr"> &copy; </div>
                        </div>


                        <div class="col-xs-12" v-for="item in configs.shopAppsItems">
                            <div style="position:relative;text-align:center;height:100px;">

                                <div class="agx-appicon-wrapper">
                                    <a :href="item.Label.Text0"> <img style="width:100%;" :src="item.Label.Label" /></a>
                                </div>
                                <div style="width:100%;bottom:0px;text-align:center;"><a :href="item.Label.Text0">{{item.Label.Text1}} </a> </div>

                            </div>
                        </div>

                        <div>
                            <shop-footer :contacts="shopContacts"></shop-footer>
                        </div>

                    </div>
                </div>
            </template>

        </layout>

    </div>
</template>


<script>
    import laws from './Laws.vue';
    import Layout from './layouts/Layout.vue';
    import Loading from './base/Loading.vue';
    import SharingButtons from './SharingButtons.vue';
    import FilterMenu from './FilterMenu.vue';
    import FilterMenuForm from './FilterMenuForm.vue';
    import PagedInfos from './PagedInfos.vue';
    import Listing from './PagedItems.vue';
    import IndexTop from './IndexTop.vue';
    import ShopContacts from './ShopContacts.vue';
    import ShopFooter from './ShopFooter.vue';
    import Slider from './slider/Slider.vue';
    import PagedQA from './PagedQA.vue';
    import LoginBox from './LoginBox.vue';

    export default {
        components: {
            Loading: Loading,
            ShopContacts: ShopContacts,
            ShopFooter: ShopFooter,
            PagedItems: Listing,
            PagedInfos: PagedInfos,
            Slider: Slider,
            PagedQa: PagedQA,
            SharingButtons: SharingButtons,
            LoginBox: LoginBox,
            FilterMenu: FilterMenu,
            FilterMenuForm: FilterMenuForm,
            IndexTop: IndexTop,
            Layout: Layout,
            laws: laws
        },
        props: {
            "shopInfo": { type: Object, default: null },
            "filterInfo": { type: Object, default: null },
            "sliderData": { type: Array, default: null },
            "enableLsToken": { type: Boolean, default: false }
        },
        computed: {
            configs: function () {
                return this.$store.getters.configs;
            },
            srcRoot: function () {
                return this.$store.getters.configs.srcRoot;
            },
            lang: function () {
                return this.$store.getters.lang;
            },
            viewType: function () {
                return this.configs.shopNature[this.shopInfo.viewCatId];
            },
            shopContacts: function () {
                return this.configs.shopContacts;
            },
            listingType: function () {
                if (this.viewType === "News") {
                    return "articles";
                }
                return "listing";
            },
            xAccount: function () {
                return this.$store.getters.account;
            },
            hasLogin: function () {
                return this.$store.getters.account !== null;
            },
            xShowingLogin: function () {
                return this.$store.getters.showingLogin;
            },
            pagedInfos: function () {
                var arr = this.configs.pagedInfos.index;
                return arr;
            },
            apiClient: function () {
                return this.mxnAgxApi.apiClient;
            }
        },
        data: function () {
            return {
                page: 1,
                showMenu: false,
                showIndexTop: this.$router.currentRoute.name === 'index',
                showLaws: true,
                isRegister: false,
                navIn: false,
                showMsgBox: false,
                isLoading: false,
                enableLsToken: false,
                currentUrl: window.location.href,
                uiApiListener: null
            }
        },
        methods: {
            toggleNav: function () {
                this.navIn = !this.navIn;
            },
            toggleMenu: function () {
                this.showMenu = !this.showMenu;
            },
            onLoginCallback: function (e) {
                this.$emit("onlogincallback", e);
                console.log("enableLsToken", this.enableLsToken);
                if (this.enableLsToken === true) {
                    var accessToken = e.value.accessToken;
                    localStorage.setItem("agx-token", accessToken);
                    this.apiClient.netClient.setBeforeRequest(function (arg) {
                        {
                            var token = localStorage.getItem("agx-token");
                            arg.headers["Agx-CJAuth"] = token;
                        }
                    });
                }
            },
            showLogin: function (toShow) {
                this.$emit("onshowlogin", toShow);
            }
        },
        created: function () {
            this.uiApiListener = {
                onScrollResolve: function (resolve, listingPosition, to, from, savedPosition) {
                    console.log("onScrollResolve");
                    var isBackButton = (savedPosition !== null && (to.name === 'listing' || to.name === 'articles' || to.name === 'index'));
                    var selectorElm = ".scrolling-container";
                    if (isBackButton) {
                        document.querySelector(selectorElm).scrollTop = listingPosition.y;
                        resolve({ selector: selectorElm, offset: listingPosition });
                    } else {
                        document.querySelector(selectorElm).scrollTop = 0;
                        resolve({ x: 0, y: 0 });
                    }
                },
                onKeepPosition: function (listPageName, to, from, next) {
                    console.log("onKeepPosition");
                    var top = document.querySelector(".scrolling-container").scrollTop;
                    if (from.name === listPageName || from.name === 'index') {
                       return top;
                    }
                }
            };
            this.mxnAgxScrollApi.on(this.uiApiListener);
        },
        destroyed: function () {
            this.mxnAgxScrollApi.remove(this.uiApiListener);
        },
        watch: {
            '$route'() {
                this.showIndexTop = this.$router.currentRoute.name === 'index';
            },
            'hasLogin'() {
                console.log("this.hasLogin", this.hasLogin);
                if (this.hasLogin === false) {
                    localStorage.setItem("agx-token", null);
                }
            }
        }
    }
</script>
